import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import AdminTitle from '../AdminTitle'
import DOMPurify from 'dompurify';
import { Toaster } from 'react-hot-toast';

type Information = {
  id: number,
  title: string,
  body: string,
  created_at: string
}[] | null

export default function InformationIndex() {
  // 求人一覧取得用の変数をセット
  const [informations, setInformations] = useState<Information>(null)

  // ページネーション表示用の状態管理
  const [nowPage, setNowPage] = useState<number>(1)
  const [allPage, setAllPage] = useState<number>(1)
  const [pageList, setPageList] = useState<number[]>([])

  // APIからお知らせ一覧を取得して表示
  useEffect(() => {
    axios.get(`/api/v1/informations`)
    .then(res => {
      setInformations(JSON.parse(res.data.data))

      const page : number = Math.ceil(res.data.count / 10)
      setAllPage(page)

      const pageArray : number[] = []
      for (let i = 1; i <= page; i++) {
        pageArray.push(i)
      }
      setPageList(pageArray)
      console.log(JSON.parse(res.data.data));
    })
    .catch(error => {
      console.log(error)
    });
  }, []);

  return (
    <>
      <AdminTitle title={'お知らせ一覧'} />
      <Toaster />
      <div className='admin-bg__color'>
        <div className='breadcrumb'>
          <ul>
            <li>お知らせ一覧</li>
          </ul>
        </div>
        <div className='admin-list__card'>
          <div className='admin-list__card__header'>
          </div>
          <div className='admin-list__card__body border-top'>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className='head-text ps-4'>タイトル</th>
                  {/* <th className='head-text'>本文</th> */}
                  <th className='head-text'>作成日</th>
                  <th className='head-text'></th>
                </tr>
              </thead>

              <tbody>
              {
                informations &&
                informations.slice((nowPage - 1) * 10, nowPage * 10).map(information =>
                  <tr key={information.id}>
                    <td className='py-4 content-text ps-4'>
                      <Link to={`/admins/informations/${information.id}`}>
                        {information.title}
                      </Link>
                    </td>
                    {/* <td dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(information.body) }}  className='py-4 content-text' /> */}
                    <td className='py-4 content-text'>{information.created_at.slice(0,10)}</td>
                    <td className='py-2 align-middle text-end'>
                      <div className="d-flex justify-content-end pe-4">
                        <Link to={`/admins/informations/${information.id}/edit`} className='btn btn-edit'>
                          <span className='material-symbols-outlined'>edit</span>
                          編　集
                        </Link>
                      </div>
                    </td>
                  </tr>
                )
              }
              </tbody>
            </table>
          </div>

          {/* ページネーション */}
          <div className='admin-list__card__footer'>
            <div className='d-flex align-items-center justify-content-center'>
              {nowPage > 1 && (
                <span className='material-symbols-outlined arrow-back arrow-back__active me-2 p-2' onClick={() => setNowPage(nowPage - 1)}>
                  arrow_back
                </span>
              )}
              {nowPage == 1 && (
                <span className='material-symbols-outlined arrow-back arrow-back__inactive me-2 p-2'>
                  arrow_back
                </span>
              )}
              {nowPage > 3 && (
                <button key={1} className='btn btn-pagenation mx-1' onClick={() => setNowPage(1)} >{1}</button>
              )}
              {nowPage > 4 && (
                <button key={2} className='btn btn-pagenation mx-1' onClick={() => setNowPage(2)} >{2}</button>
              )}
              {nowPage > 5 && (
                <button key={3} className='btn btn-pagenation mx-1' onClick={() => setNowPage(3)} >{3}</button>
              )}
              {nowPage > 5 && (
                <span className='mx-2'>...</span>
              )}
              {pageList
                .filter(page => page >= Math.max(1, nowPage - 2) && page <= Math.min(allPage, nowPage + 2))
                .map(page => (
                  <button
                    key={page}
                    className={`btn btn-pagenation mx-1 ${page === nowPage ? 'active' : ''}`}
                    onClick={() => setNowPage(page)}
                  >
                    {page}
                  </button>
                ))
              }
              {allPage - nowPage > 5 && (
                <span className='mx-2'>...</span>
              )}
              {allPage - nowPage > 4 && (
                <button key={allPage - 2} className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage - 2)} >{allPage - 2}</button>
              )}
              {allPage - nowPage > 3 && (
                <button key={allPage - 1} className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage - 1)} >{allPage - 1}</button>
              )}
              {allPage - nowPage > 2 && (
                <button key={allPage } className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage )} >{allPage }</button>
              )}
              {nowPage < allPage && (
                <span className='material-symbols-outlined arrow-next arrow-next__active' onClick={() => setNowPage(nowPage + 1)}>
                  arrow_forward
                </span>
              )}
              {nowPage == allPage && (
                <span className='material-symbols-outlined arrow-next arrow-next__inactive'>
                  arrow_forward
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
